/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".tile_5e7d60e2{display:inline-block;position:relative;margin:4px}.smallTile_5e7d60e2{width:138px;height:135px}.largeTile_5e7d60e2{width:176px;height:171px}.tileFolder_5e7d60e2{display:inline-block;margin:3px}.tileImage_5e7d60e2{display:block}\n"}]);
export const tile = "tile_5e7d60e2";
export const smallTile = "smallTile_5e7d60e2";
export const largeTile = "largeTile_5e7d60e2";
export const tileFolder = "tileFolder_5e7d60e2";
export const tileImage = "tileImage_5e7d60e2";